// ENG-20855: native calendar grid that replaces Quasar's QDate inside the date components.
export interface MCalendarGridProps {
  /** selected date as "DD/MM/YYYY" */
  modelValue?: string | null;
  /** earliest selectable date (inclusive) */
  minDate?: Date | string | number;
  /** latest selectable date (inclusive) */
  maxDate?: Date | string | number;
  /** which panel to show first — "months" opens the month chooser (used by the month picker) */
  initialView?: "days" | "months";
}

export const mCalendarGridDefaults = {
  modelValue: null,
  initialView: "days",
} satisfies Partial<MCalendarGridProps>;
